import { useEffect, useState } from 'react';

/**
 * A clock the render is allowed to read — GEN-68.
 *
 * `Date.now()` in a render body is not idempotent and `react-hooks/purity` refuses it, so
 * the tick is state and an effect advances it. `running` is the judgment that stops the
 * poll: a settled job is measured to its own `finishedAt`, so ticking for it re-renders a
 * string that cannot change.
 */
export function useNow(running: boolean): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!running) return undefined;

    const timer = setInterval(() => {
      setNow(Date.now());
    }, 1_000);

    return () => {
      clearInterval(timer);
    };
  }, [running]);

  return now;
}
